{
    "component-card-search-list.empty-state.title.non-final": "<strong>Połącz to repozytorium z komponentem oprogramowania</strong>",
    "component-card.add-chat-channel": "Dodaj kanał czatu",
    "component-card.chat-channels": "Kanały czatu",
    "component-card.expander.show-more-link": "Pokaż jeszcze {formattedCount}"
}
